import classes from './Home.module.css';

const Home = () => {
    return (
        <div style={{direction: 'rtl'}}>
            <div className={classes.header}>header</div>
            <div>
                <div style={{ height: '100px' }}></div>
                <div className={classes.sectionOne}></div>
                <div className={classes.sectionTwo}>
                    {/* <div className={classes.sectionTwoA}>aaaaa</div> */}
                    {/* <div className={classes.sectionTwoB}>bbbb</div> */}
                    <div style={{textAlign: 'center'}}>
                        <div><h3>נעים להכיר, אנחנו</h3></div>
                        <div><h2 style={{color: '#ad8231', fontSize: '80px'}}>Vitrue</h2></div>
                        <div><p style={{fontSize: '24px', fontWeight: 'bold'}}>מובילים את המשק הישראלי לשיפור וייעול<br />תהליכים עסקיים בעזרת צ׳אטבוטים למען הגדלת הרווחיות.</p></div>
                        <div style={{width: '800px', maxWidth: '100%', margin: 'auto', fontSize: '24px'}}><p>כבר למעלה מ-6 שנים שאנחנו משלבים בין חשיבה עסקית אסטרטגית לבין יכולות פיתוח מתקדמות כדי להוביל עסקים וחברות להצלחה בלתי מתפשרת. עם ניסיון עסקי רחב וצוות מומחים, אנחנו מתמחים בייעול תהליכים ויצירת אוטומציות שמטרתם למצות את הרווחיות והפוטנציאל הגלום בעסק.</p></div>
                    </div>

                    <div style={{paddingTop: '100px', width: '86%', margin: 'auto'}}>
                        <img style={{maxWidth: '100%'}} src="https://www.vitrue.co.il/wp-content/uploads/2024/01/הצוות-שלנו-1-scaled.png" />
                    </div>
                </div>
            </div>
            <div className={classes.footer}>footer</div>
        </div>
    );
}

export default Home;